import React, { useState, useEffect } from 'react';
import { Fab, Zoom, useScrollTrigger } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const ScrollToTopFab = ({ triggerRef }) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        if (!triggerRef?.current) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                // Determine if the "Save" button is out of view logic
                // entry.isIntersecting means the button is visible in viewport
                // We want to show FAB when button is NOT visible (scrolled past)
                // However, we want it specifically when scrolled *down* usually, 
                // but requirement is "whenever top save button is hidden".

                // If the save button is NOT intersecting, show the FAB.
                setIsVisible(!entry.isIntersecting);
            },
            {
                root: null, // viewport
                threshold: 0, // as soon as even 1px is out? or fully out. 0 means as soon as it enters/leaves.
                rootMargin: "-20px 0px 0px 0px" // Slight offset
            }
        );

        observer.observe(triggerRef.current);

        return () => {
            if (triggerRef.current) observer.unobserve(triggerRef.current);
        };
    }, [triggerRef]);

    const handleClick = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <Zoom in={isVisible}>
            <Fab
                color="primary"
                size="medium"
                onClick={handleClick}
                sx={{
                    position: 'fixed',
                    bottom: 32,
                    right: 32,
                    zIndex: 1000,
                    boxShadow: 3
                }}
                aria-label="scroll back to top"
            >
                <KeyboardArrowUpIcon />
            </Fab>
        </Zoom>
    );
};

export default ScrollToTopFab;
